(function($) {
    
	var pingTimeout = null;
	var dbUpgradeRequired = false;
	var progressTitle;
	var dbUpgrade;
	var uploadError;
	var restartingText;
	var restartTimeout;
 	var restart;
	var restartProgress;
	var restartFailed;
	var restartDone;
	var callback;
	var callbackArguments = null;
	var hideSuccessStatus = false;
	
	$.restart = function(options){
		
		if(!!options){
			if(!!options.pingTimeout){
				pingTimeout = options.pingTimeout;
			}
			if(!!options.dpUpgradeRequired){
				dpUpgradeRequired = options.dpUpgradeRequired;
			}
			if(!!options.progressTitle){
				progressTitle = options.progressTitle;
			}
			if(!!options.dbUpgrade){
				dbUpgrade = options.dbUpgrade;
			}
			if(!!options.uploadError){
				uploadError = options.uploadError;
			}
			if(!!options.restartingText){
				restartingText = options.restartingText;
			}
			if(!!options.restartTimeout){
				restartTimeout = options.restartTimeout;
			}
			if(!!options.restart){
				restart = options.restart;
			}
			if(!!options.restartProgress){
				restartProgress = options.restartProgress;
			}
			if(!!options.restartFailed){
				restartFailed = options.restartFailed;
			}
			if(!!options.restartDone){
				restartDone = options.restartDone;
			}
			if(!!options.callback){
				callback = options.callback;
			}
			if(!!options.callbackArguments){
				callbackArguments = options.callbackArguments;
			}
			if(!!options.hideSuccessStatus){
				hideSuccessStatus = options.hideSuccessStatus;
			}
		}
		
//		$.displayProgressBar(restart, restartProgress);
		$.displayLoadingIndicator(restartingText);
		var promise = $.getJSON('maintenance/restart', {nocache: new Date().getTime()});
					
		promise.done(function(data){
			if (!data.success){
				$.showErrorStatus(restartFailed);
			}
			else{
				$.displayLoadingIndicator(restartingText);
                $('.animated-logo-wrapper').addClass('restart');
                $.loopProgressBar();
				var timeout = getTestingTimeout() || 600;
				pollServer(timeout);
			}
		});
	};
	
	/*
	 * this function waits for the server to go down, then pings	
	 * it every 10 seconds until it's back up or 'timeout' is reached
	 */ 
	function pollServer(timeout){
		
		var pollPromise = null;
		var down = false;
		var gracePeriod = false;
		var progressInterval;
		
		// ping the server every 5 seconds
		var pingInterval = setInterval(function(){
			pollPromise =  $.getJSON('maintenance/ping', {nocache: new Date().getTime()});
			pollPromise.then(function(){
				// if the request went down previously, and is now back up, we're good
				if (down == true){	
					$.debugLog('request succeeded after restart');
					clearInterval(pingInterval);
					clearTimeout(pingTimeout);
					$.removeProgressBar();
					if(!hideSuccessStatus) {
						$.removeLoadingIndicator();
					}
		            $('.animated-logo-wrapper').removeClass('restart');
					if (dbUpgradeRequired == false){
						$.debugLog('restart not required, showing success message');
						if(!hideSuccessStatus) {
							$.showSuccessStatus(restartDone);
						}
						if(!!callback) {
							callback.call(this, callbackArguments);
						}
					}
					else{
						$.debugLog('restart is required, upgrading database.');							
			    		$.displayProgressBar(progressTitle, dbUpgrade);
			    		progressInterval = setInterval(function(){
			    			var progress = $.getJSON('database/getPercentDone', {nocache: new Date().getTime()});
			    			progress.done(function(data){
			    				if (data.success == true){
			    					$.updateProgressBar(data.percentDone);
			    				}
			    			});
			    		}, 1000);
						        
						var dbupgrade =  $.getJSON('database/maintenanceUpgrade', {nocache: new Date().getTime()});
						
						dbupgrade.fail(function(){
			                clearInterval(progressInterval);
			                $.debugLog('unexpected error calling database delegate');
							$.showErrorStatus('com.compuware.ces.dbUpgradeError');
						});

				        dbupgrade.done(function(result){
			                clearP2Progress();
			                clearInterval(progressInterval);
							if (result.success == false){
								showErrorPopUp(result.message, result.SQL, result.info);
							}
							else{
								$.showSuccessStatus(result.message);
								reset();
							}
						});
					}
				}				
			}, 
			// failed ping callback
			function(err){	
				$.debugLog('ping failed...');
				// when ping fails, set the down status
				if (!down){
					$.debugLog('service has stopped responding...');
					down = true;
				}
				if (err.status == 404 && down && !gracePeriod){
					gracePeriod = true;
					clearTimeout(pingTimeout);
					setPingTimeout(pingInterval, timeout);
					$.debugLog('service has responded with error, extending timeout for OSGi grace period...');
				}
			});
		}, 5000);
		
		setPingTimeout(pingInterval, timeout);
	};
	
	function setPingTimeout(pingInterval, timeout){
		// after timeout minutes, we give up pinging
		pingTimeout = setTimeout(function(){
			$.debugLog('timeout reached, service has not responded');
			clearInterval(pingInterval);
			clearTimeout(pingTimeout);
			$.removeProgressBar();
			$.showMessageDialog({
				title: uploadError, 
				message: restartTimeout,
				okCallback: function(){}
			});
		}, 1000 * timeout);
	}
	
	function getTestingTimeout(){
		var queryString = location.search
		
    	var matches = /\?.*timeout=(\d*)&?/i.exec(queryString);
		if (matches){
			return matches[1];
		}
	};
	
})(jQuery);